import React, { FunctionComponent } from 'react';
// import styles from "./Play.module.scss";
import playButton from "../../../images/playButton.svg";
import pauseButton from "../../../images/pauseButton.svg";


/**
 * Primary UI component for user interaction
 */
const Play = ({ ariaPressed, toggle = false, alt, ariaLabel, onClick, tabIndex}) => {

  let toggleImage = toggle ? <img alt={"Pause Button"} src={pauseButton} /> : <img alt={"Play Button"} src={playButton} />;

  return (
  <div
        aria-pressed={ariaPressed}
        aria-live="polite"
        role="button"
        aria-atomic="true"
        //@ts-ignore
        // alt={`${ariaPressed ? 'Pause Button' : 'Play Button'} ${alt}`}
        className={'playButton'}
        tabIndex={tabIndex}
        aria-label={`${ariaPressed ? 'Pause Button' : 'Play Button'} ${ariaLabel}`}
        onClick={() => onClick()}
        style={{ }}
        onKeyPress={() => onClick()}
    >
      {toggleImage}
    </div>
  );
};

export default Play;
